import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronRight, ClipboardCheck, UserCog, UserMinus } from 'lucide-react';
import clsx from 'clsx';
import type { AdminQuickActionsData } from '@app-types';
import styles from './ProgramLeadQuickActions.module.css';
import tones from './AssessorQuickActions.module.css';

interface AdminQuickActionsProps {
  data: AdminQuickActionsData | undefined;
  isLoading: boolean;
}

// Pending Division Verification and Pending Division Updates wait for their indicators (CTU-4.1, CTU-4.2).
const AdminQuickActions: React.FC<AdminQuickActionsProps> = ({ data, isLoading }) => {
  const navigate = useNavigate();

  const actions = [
    {
      label: 'Pending Contact Users',
      count: data?.pending_contact_users,
      icon: UserCog,
      tone: tones.iconWarning,
      route: '/users?status=pending'
    },
    {
      label: 'Pending Inactivation',
      count: data?.pending_inactivation,
      icon: UserMinus,
      tone: tones.iconDanger,
      route: '/users?status=pending-inactivation'
    },
    {
      label: 'Jobs Pending Review',
      count: data?.jobs_pending_review,
      icon: ClipboardCheck,
      tone: tones.iconWarning,
      route: '/admin/data-management?tab=import-jobs&completion=pending'
    }
  ];

  return (
    <div className={styles.quickActionsContainer}>
      <div className={styles.actionsGrid}>
        {actions.map((action) => {
          const IconComponent = action.icon;
          return (
            <button
              type="button"
              key={`action-${action.label}`}
              className={clsx(styles.actionTile, tones.tile)}
              onClick={() => navigate(action.route)}
            >
              <div className={clsx(styles.actionIcon, action.tone)}>
                <IconComponent size={24} />
              </div>
              <div className={styles.actionContent}>
                <p className={styles.actionLabel}>{action.label}</p>
                <p className={styles.actionCount}>{isLoading ? '–' : (action.count ?? 0)}</p>
              </div>
              <ChevronRight size={20} className={styles.actionArrow} />
            </button>
          );
        })}
      </div>
    </div>
  );
};

export { AdminQuickActions };
